
import { defineAsyncComponent, defineComponent, onMounted, ref, watchEffect } from "vue";
import folder from "@/assets/icons/folder.svg";
import whiteFolder from "@/assets/icons/folder-white.svg";
import info from "@/assets/icons/infos.svg";
import whiteInfo from "@/assets/icons/infos-white.svg";
import { useStore } from "vuex";
const Button = defineAsyncComponent(() => import("@/components/elements/Button.vue"));
const ModalTemplate = defineAsyncComponent(() => import("@/components/modal/ModalTemplate.vue"));
const MediaPreview = defineAsyncComponent(() => import("@/components/elements/forms/MediaPreview.vue"));

export default defineComponent({
  components: {
    Button,
    MediaPreview,
    ModalTemplate,
  },
  emits: ["changeMedia", "closeModal"],
  props: {
    name: {
      type: String,
      required: true,
    },
    mediaType: {
      type: String, // image | video
      required: true
    },
    openModal: Boolean,
    title: String,
  },
  setup(props, { emit }) {
    const store = useStore();
    const src = ref();
    const srcPreview = ref();
    const srcDuration = ref();
    const hover = ref(false);
    let finalFolder = ref(folder);
    let finalInfo = ref(info);
    const closeTrigger = ref();

    const changeImgTheme = () => {
      if (store.state.navigationButton.darkMode == "dark") {
        finalFolder.value = whiteFolder;
        finalInfo.value = whiteInfo;
      } else {
        finalFolder.value = folder;
        finalInfo.value = info;
      }
    };

    onMounted(() => {
      changeImgTheme();
    });

    watchEffect(() => {
      store.state.navigationButton.darkMode;
      changeImgTheme();
    });

    const loadFile = (files: Array<File>) => {
      src.value = files[0];
    }

    const dragPicture = (e: any) => {
      return loadFile(e.dataTransfer.files);
    };

    const inputAddPicture = (e: any) => {
      return loadFile(e.target.files);
    };

    const restoreLocalData = () => {
      emit("closeModal");
      src.value = null;
      srcPreview.value = null;
      srcDuration.value = null;
      closeTrigger.value = false;
    };

    const submit = () => {
      if (src.value) {
        emit("changeMedia", { media: src.value, mediaPreview: srcPreview.value, mediaDuration: srcDuration.value });
      }
      restoreLocalData();
    };

    const onPreviewLoaded = ({mediaPreview, mediaDuration}: any) => {
      srcPreview.value = mediaPreview;
      srcDuration.value = mediaDuration;
    }

    return {
      finalFolder,
      info,
      src,
      srcPreview,
      hover,
      dragPicture,
      inputAddPicture,
      submit,
      finalInfo,
      whiteInfo,
      closeTrigger,
      restoreLocalData,
      onPreviewLoaded,
    };
  },
});
